import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/AdorSMPSEnergyHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-25.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ace { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .ace-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .ace-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .ace-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .ace-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .ace-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .ace-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .ace-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .ace-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .ace-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .ace-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .ace-bc-item:hover { color: #EB2019; }
  .ace-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .ace-bc-sep img { width: 24px; height: 24px; display: block; }
  .ace-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .ace-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .ace-main-section { padding: 80px 0 120px 0; }
  .ace-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .ace-article { flex: 1; min-width: 0; }

  .ace-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .ace-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .ace-meta-item:last-child { border-right: none; padding-right: 0; }
  .ace-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .ace-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .ace-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .ace-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ace-article-body p { margin-bottom: 20px; }
  .ace-article-body p:last-child { margin-bottom: 0; }

  .ace-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 15px 0; line-height: 160%; display: block;
  }

  .ace-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 10px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .ace-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .ace-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ace-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .ace-article-body ul li > span { flex: 1; }

  .ace-article-body strong { font-weight: 600; color: #202020; }

  .ace-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .ace-red-link:hover { opacity: 0.8; }
  .ace-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 400; }
  .ace-red-link-plain:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .ace-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .ace-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .ace-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .ace-nav-btn:hover { color: #EB2019; }
  .ace-nav-btn img { width: 40px; height: 40px; display: block; }

  .ace-share-icons { display: flex; align-items: center; gap: 20px; }
  .ace-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .ace-share-icon:hover { opacity: 0.85; }
  .ace-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .ace-sidebar { flex: 0 0 475px; }
  .ace-sidebar-block { margin-bottom: 60px; }
  .ace-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .ace-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .ace-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .ace-recent-item:hover .ace-recent-title { color: #EB2019; }
  .ace-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .ace-recent-body { flex: 1; min-width: 0; }
  .ace-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .ace-social-icons { display: flex; align-items: center; gap: 30px; }
  .ace-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .ace-social-icon:hover { opacity: 0.8; }
  .ace-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .ace-hero             { height: 350px; }
    .ace-hero-content     { padding: 0 32px; }
    .ace-hero-title       { font-size: 30px; }
    .ace-hero-divider     { width: 100%; max-width: 479px; }
    .ace-breadcrumb       { padding: 24px 0 0 0; }
    .ace-breadcrumb-inner { padding: 0 32px; }
    .ace-inner            { padding: 0 32px; }
    .ace-main-section     { padding: 48px 0 60px 0; }
    .ace-main-row         { flex-direction: column; gap: 48px; }
    .ace-sidebar          { flex: none; width: 100%; }
    .ace-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .ace-hero             { height: 360px; }
    .ace-hero-content     { padding: 0 16px; }
    .ace-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .ace-hero-divider     { width: 100%; }
    .ace-hero-subtitle    { font-size: 14px; }
    .ace-breadcrumb       { padding: 30px 0 0 0; }
    .ace-breadcrumb-inner { padding: 0 16px; }
    .ace-bc-item          { font-size: 14px; gap: 14px; }
    .ace-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .ace-bc-sep img       { width: 22px; height: 22px; }
    .ace-inner            { padding: 0 16px; }
    .ace-main-section     { padding: 30px 0 60px 0; }
    .ace-main-row         { flex-direction: column; gap: 60px; }
    .ace-sidebar          { flex: none; width: 100%; }
    .ace-article-title    { font-size: 20px; margin-bottom: 15px; }
    .ace-article-body     { font-size: 14px; }
    .ace-article-body p   { margin-bottom: 15px; }
    .ace-article-body ul  { margin: 0 0 20px 0; gap: 10px; }
    .ace-article-body ul li { font-size: 14px; }
    .ace-meta-item        { font-size: 14px; }
    .ace-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .ace-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .ace-h3               { font-size: 14px; margin: 15px 0 10px 0; }
    .ace-nav-btn img      { width: 24px; height: 24px; }
    .ace-nav-btn          { font-size: 14px; }
    .ace-share-icon img   { width: 34px; height: 34px; }
    .ace-sidebar-title    { font-size: 20px; }
  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function AdorpowertronSMPSCutsEnergyConsumption() {
  return (
    <div className="ace">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="ace-hero">
        <img className="ace-hero-bg" src={HeroBgImg} alt="Adorpowertron SMPS Energy Hero" />
        <div className="ace-hero-overlay" />
        <div className="ace-hero-content">
          <h1 className="ace-hero-title">
            How Adorpowertron's SMPS Cuts Energy Consumption across Industries?
          </h1>
          <hr className="ace-hero-divider" />
          <p className="ace-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="ace-breadcrumb" aria-label="Breadcrumb">
        <div className="ace-breadcrumb-inner">
          <a href="/" className="ace-bc-item">Home</a>
          <span className="ace-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="ace-bc-item">News &amp; Updates</a>
          <span className="ace-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ace-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="ace-main-section">
        <div className="ace-inner">
          <div className="ace-main-row">

            {/* ── ARTICLE ── */}
            <article className="ace-article">

              {/* Meta bar */}
              <div className="ace-meta-bar">
                <span className="ace-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="ace-meta-item"><img src={CalendarIcon} alt="date" /> March 5, 2025</span>
                <span className="ace-meta-item"><img src={ClockIconImg} alt="time" /> 11:01 am</span>
                <span className="ace-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="ace-article-title">
                How Adorpowertron's SMPS Cuts Energy Consumption across Industries?
              </h1>

              {/* Body */}
              <div className="ace-article-body">

                <p>Industries continually aspire to energy-efficient solutions to decrease power consumption and lower operational expenses. One such creation is SMPS Power (Switch Mode Power Supply). It delivers increased efficiency and minimal energy loss.</p>

                <p>Ador Powertron, a leader in advanced power solutions, provides cutting-edge Switch Mode Power Supply (SMPS) technology to optimize energy use across multiple industries.</p>

                <p>This blog explores how Ador Powertron's SMPS helps diverse sectors.</p>

                {/* Article image */}
                <img className="ace-article-img" src={ArticleImg} alt="Adorpowertron SMPS Power Supply" />

                <span className="ace-h2">SMPS Power</span>

                <span className="ace-h2">Let's explore!</span>

                <p>Switch Mode Power Supply (SMPS) is an advanced power conversion system that efficiently regulates voltage and current. Unlike traditional power supplies, SMPS Power uses high-frequency switching technology to convert electrical energy with minimal loss.</p>

                <span className="ace-h2">Essential Benefits of SMPS Power:</span>

                <ul>
                  <li><span><strong>Higher Efficiency –</strong> Converts power with up to 90% efficiency, reducing wasted energy.</span></li>
                  <li><span><strong>Compact Design –</strong> Smaller and lighter compared to conventional transformers.</span></li>
                  <li><span><strong>Minimal Heat Generation –</strong> Less power dissipation leads to cooler operation.</span></li>
                  <li><span><strong>Reliable and Durable –</strong> Designed for long-term, high-performance operation.</span></li>
                </ul>

                <span className="ace-h2">How Does Ador Powertron's SMPS Reduce Energy Consumption?</span>

                <p>Ador's SMPS technology is engineered to fulfill the energy efficiency needs of current industries. Here's how it helps cut energy consumption:</p>

                <span className="ace-h3">1. Intelligent Power Regulation</span>
                <ul>
                  <li><span>It adjusts voltage and current based on the need, assuring no wastage of excess energy.</span></li>
                  <li><span>This intelligent power regulation optimizes energy flow, reducing unnecessary consumption.</span></li>
                </ul>

                <span className="ace-h3">2. High-Efficiency Conversion</span>
                <ul>
                  <li><span>Standard power supplies lose energy in the form of heat.</span></li>
                  <li><span>Ador Powertron's SMPS Power technology assures minimal energy loss, restoring and converting more power into practical output.</span></li>
                </ul>

                <span className="ace-h3">3. Decreased Heat Dissipation</span>
                <ul>
                  <li><span>More inferior heat generation means less cooling is needed, which ushers to extra energy savings.</span></li>
                  <li><span>Industries employing SMPS Power benefit from improved operational efficiency and lower electricity prices.</span></li>
                </ul>

                <span className="ace-h3">4. Adaptability to diverse Industrial requirements</span>
                <ul>
                  <li><span>Whether telecommunications, automation, or healthcare, Ador Powertron's SMPS delivers long-lasting, energy-efficient power.</span></li>
                  <li><span>Its adaptability assures optimal performance across diverse voltage and frequency necessities.</span></li>
                </ul>

                <span className="ace-h2">Industries Benefiting from Ador Powertron's SMPS Power</span>

                <p>Many industries rely on Ador Powertron's SMPS to improve efficiency and reduce power consumption:</p>

                <ul>
                  <li><span><strong>Telecommunications –</strong> Ensures stable and efficient power supply to network infrastructure.</span></li>
                  <li><span><strong>Industrial Automation –</strong> Powers robotic and automated systems with high precision.</span></li>
                  <li><span><strong>Healthcare –</strong> Delivers trustworthy power for medical equipment, decreasing energy trash.</span></li>
                  <li><span><strong>Renewable Energy –</strong> Improves the efficiency of solar and wind power systems.</span></li>
                  <li><span><strong>Electronics &amp; Manufacturing –</strong> Supports precision power needs with minimal energy loss.</span></li>
                </ul>

                <span className="ace-h2">Why Choose Ador Powertron's SMPS?</span>

                <ul>
                  <li><span><strong>Proven Energy Savings –</strong> Reduces power consumption without compromising performance.</span></li>
                  <li><span><strong>Advanced Technology –</strong> Made with advanced SMPS inventions.</span></li>
                  <li><span><strong>Trustworthy and Long-lasting –</strong> Provides long-lasting and uniform performance.</span></li>
                  <li><span><strong>Industry Expertise –</strong> Counted by leading industries for efficient power solutions.</span></li>
                </ul>

                <span className="ace-h2">Conclusion</span>

                <p>There is an increasing need for energy-efficient solutions. Ador Powertron understands this need and offers solutions aligned with the customer's references and requirements. Its <a href="/news/designing-efficient-smps-coal" className="ace-red-link-plain">SMPS</a> Power technology is a game-changer across industries. Delivering high efficiency, reduced power loss, and reliable performance helps businesses cut energy costs while maintaining superior operations.</p>

                <p>Want to optimize your energy consumption? Explore our sustainable solutions today. Contact us now!</p>

                <p><a href="/contact-us" className="ace-red-link">Contact us today!</a></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="ace-bottom-row">
                <div className="ace-bottom-nav">
                  <a href="/news/smps-vs-traditional-power-supplies" className="ace-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/esp-thermal-power-plants-efficiency" className="ace-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="ace-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/how-adorpowertrons-smps-cuts-energy-consumption-across-industries/" className="ace-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fhow-adorpowertrons-smps-cuts-energy-consumption-across-industries%2F&mode=login" className="ace-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-adorpowertrons-smps-cuts-energy-consumption-across-industries%2F%26title%3DAdor%2520Powertron%2520SMPS%2520%25E2%2580%2593%2520Reduce%2520Energy%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-adorpowertrons-smps-cuts-energy-consumption-across-industries%2F" className="ace-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="ace-sidebar">

              {/* Recent Posts */}
              <div className="ace-sidebar-block">
                <p className="ace-sidebar-title">Recent Posts</p>
                <div className="ace-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="ace-recent-item">
                      <img src={post.img} alt={post.title} className="ace-recent-img" />
                      <div className="ace-recent-body">
                        <span className="ace-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="ace-sidebar-block">
                <p className="ace-sidebar-title">Social Media</p>
                <div className="ace-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="ace-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="ace-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}